export default __webpack_public_path__ + "src/images/packages/the-african-renaissance/64d14719dcd431da5d8e2a629599c35d-1.jpg";